import About from "./components/About";
import Contact from "./components/Contact";
import Hero from "./components/Hero";
import Navbar from "./components/Navbar";
// import NFT from "./components/NFT";
// import Projects from "./components/Projects";
import SocialLinks from "./components/SocialLinks";
import GotoTop from "./components/GotoTop";
import { RotatingSquare } from "react-loader-spinner";
import "./index.css";
import { useState, useEffect } from "react";
// import NewProjects from "./components/NewProjects";
import Blogs from "./components/Blogs";
import Talks from "./components/Talks";
import Packages from "./components/Packages";

function App() {
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 2500);
  }, []);

  return (
    <>
      {loading ? (
        <RotatingSquare
          height="100"
          width="100"
          color="#FC5130"
          ariaLabel="rotating-square-loading"
          strokeWidth="4"
          wrapperStyle={{}}
          wrapperClass="loader"
          visible={true}
        />
      ) : (
        <div>
          <Navbar />
          <Hero />
          <About />
          <Packages />
          {/* <NewProjects /> */}
          {/* <Projects /> */}
          <Blogs />
          {/* <NFT /> */}
          <Talks />
          <GotoTop />
          <Contact />

          <SocialLinks />
        </div>
      )}
    </>
  );
}

export default App;
